import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'AppEngineService'
const host = servicesConfig.AppEngine
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

// Define service object with methods
const AppEngineService = {
  getFacebookPages: (locationId: string) => 
    request().get(`/facebook/get_pages/${locationId}`).then(responseBody)
}

export default AppEngineService